import { createContext, useReducer, useEffect } from 'react';

export const AuthSlice = createContext();

export const authReducer = (state, action) => {
    switch (action.type) {
        // Cases for admin
        case 'ADMIN_LOGIN':
            return {
                ...state,
                admin: action.payload
            };
        case 'ADMIN_LOGOUT':
            return {
                ...state,
                admin: null
            };
        default:
            return state;
    }
};

export const AuthContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, {
        admin: null,
    });

    useEffect(() => {
        // Helper function to get user data from storage
        const getUserDataFromStorage = (key) => {
            const dataFromLocalStorage = localStorage.getItem(key);
            const dataFromSessionStorage = sessionStorage.getItem(key);

            return dataFromLocalStorage
                ? JSON.parse(dataFromLocalStorage)
                : dataFromSessionStorage
                    ? JSON.parse(dataFromSessionStorage)
                    : null;
        };

        // Check for admin in both localStorage and sessionStorage
        const admin = getUserDataFromStorage('admin');
        if (admin) {
            dispatch({ type: 'ADMIN_LOGIN', payload: admin });
        }
    }, []);

    return (
        <AuthSlice.Provider value={{ ...state, dispatch }}>
            {children}
        </AuthSlice.Provider>
    );
};
